/**
 * tokenize.ts — TOKENIZAÇÃO DO CARTÃO NO CLIENT.
 *
 * ⚠️ PONTO DE INTEGRAÇÃO com o gateway (Asaas). Em PRODUÇÃO, aqui se carrega o SDK
 * do Asaas e chama a tokenização — o PAN/CVV vão direto do navegador para o gateway,
 * e o backend NUNCA vê os dados do cartão (fica fora do escopo PCI).
 *
 * Exemplo (produção, Asaas):
 *   const asaas = await loadAsaasSdk(PUBLIC_KEY);
 *   const { creditCardToken } = await asaas.tokenizeCreditCard({ ... });
 *   return creditCardToken;
 *
 * Sem conta Asaas neste ambiente, geramos um token de DEMONSTRAÇÃO no client.
 * Nenhum dado real de cartão é enviado ao servidor (só o token sintético).
 */
export interface CardData {
  numero: string;
  nome: string;
  validade: string;
  cvv: string;
}

export async function tokenizeCard(card: CardData): Promise<string> {
  // Demo: número terminando em 0000 simula recusa; qualquer outro, aprovação.
  const digits = card.numero.replace(/\D/g, '');
  await new Promise((r) => setTimeout(r, 300)); // simula a ida ao gateway
  return digits.endsWith('0000') ? 'tok_recusado' : 'tok_aprovado';
}
